module.exports = __webpack_public_path__ + "img/Wifi-Adapter.c4350f18.png";